module.exports = __webpack_public_path__ + "static/media/picto_parcour_poker.82dde79e.png";